$(".submit-input").on("click", function() {
  var form = $(this).parents("form");
  submitForm(form);
});

function submitForm(form) {
  form.submit();
}